import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ModalCommonOptions } from 'projects/common-lib/src/lib/modal/modal-common-options';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventModel, EventElementModel } from 'projects/common-lib/src/lib/ux-models';
import { Helper, Log } from 'projects/core-lib/src/lib/helpers/helper';

@Component({
  selector: 'ib-modal-simple-alert',
  templateUrl: './modal-simple-alert.component.html',
  styleUrls: ['./modal-simple-alert.component.css']
})
export class ModalSimpleAlertComponent implements OnInit, OnChanges {

  @Input() public options: ModalCommonOptions = new ModalCommonOptions();
  //@Output() public onOk: EventEmitter<EventModel> = new EventEmitter();
  //@Output() public onCancel: EventEmitter<EventModel> = new EventEmitter();

  /**
   * The constructor
   * @param modal The NgbModal service will inject the active modal here so we can close or dismiss the modal from inside this component.
   */
  constructor(public modal: NgbActiveModal) { }

  ngOnInit() {
    this.configure();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.configure();
  }

  protected configure() {

    if (!this.options) {
      this.options = new ModalCommonOptions();
    }

    // For simple alert modals we do not want to show alerts in the modal
    this.options.showAlerts = false;

    if (!this.options.title && !this.options.message) {
      this.options.message = "There was no message provided to show.<br/><br/><small>";
      const trace = Log.getStackTrace();
      trace.forEach((line) => {
        this.options.message += line + "<br/>";
      });
      this.options.message += "</small>";
    }
    // We need text or icon on at least one of our buttons
    if (!this.options.okButtonText && !this.options.okButtonIcon && !this.options.cancelButtonText && !this.options.cancelButtonIcon) {
      this.options.okButtonText = "Ok";
    }

  }

}
